<template>
  <div>
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <h2
        class="mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900"
      >
        Lost Password
      </h2>
    </div>
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <h2 class="mt-6 text-center text-gray-900">
        It happens to the best of us. Enter your email address and we'll send
        you a link to reset your password.
      </h2>
    </div>
    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <form @submit.prevent="lostPassword">
        <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div>
            <WwpLabel>Email</WwpLabel>
            <div class="mt-1 rounded-md shadow-sm">
              <WwpInput v-model="email"></WwpInput>
            </div>
          </div>
          <div class="mt-6">
            <span class="block w-full rounded-md shadow-sm">
              <button
                class="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out"
              >
                Get Link
              </button>
            </span>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import WwpInput from "../ui/forms/BaseInput";
import WwpLabel from "../ui/forms/BaseLabel";

export default {
  name: "LostPassword",
  components: {
    WwpLabel,
    WwpInput,
  },
  data() {
    return {
      email: "",
    };
  },
  methods: {
    lostPassword() {
      this.$store
        .dispatch("auth/lost_password", { email: this.email })
        .then(() => {
          this.$notify({
            title: "Lost Password",
            message:
              "If this email is in our system then an email has been sent with instructions to reset your password",
            type: "success",
          });
        });
    },
  },
};
</script>
